import { PopoverComboboxOption } from '@/components/ui/custom/PopoverCombobox';
import { useDeskId } from '@/hooks/useDeskId';
import { useBundles } from '@/modules/bundles/hooks/useBundles';

export const useBundleOptions = () => {
  const deskId = useDeskId();
  const { bundles, listStatus } = useBundles(deskId);
  const options: PopoverComboboxOption[] = (bundles ?? []).map(({ bundle_id, name }) => ({
    value: bundle_id,
    label: name,
  }));
  return { options, isLoading: listStatus === 'pending' };
};
